import { ProductAllInfo } from '../../pages/app/App';
import {
  Container,
  ButtonInstagram,
  EmptyContactMessage,
} from './styles';
import { BsInstagram } from 'react-icons/bs';
import { moneyFormat } from '../../utils/moneyFormat';
import { dateFormat } from '../../utils/dateFormat';
import { WhatsAppButton } from '../Button';

export const BodyModalProductSelected = ({
  endOffer,
  location,
  newPrice,
  oldPrice,
  productTitle,
  shopName,
  productImageUrl,
  whatsapp,
  instagram,
}: ProductAllInfo) => {
  return (
    <Container>
      <div className="card-container">
        <img src={productImageUrl} alt="Product Image" />
        <div className="shop-info">
          <p className="product-title">{productTitle}</p>
          <p className="date">{`Válido até ${dateFormat(
            endOffer,
          )} ou até durarem os estoques`}</p>
          <p className="old-price">{moneyFormat(oldPrice)}</p>
          <p className="new-price">{moneyFormat(newPrice)}</p>
        </div>
      </div>
      <p className="shop-name text-bold">{shopName}</p>
      <p className="shop-location">{location}</p>
      <p className="text-bold">Reservar o produto:</p>
      {whatsapp && (
        <WhatsAppButton
          href={`https://wa.me/${whatsapp}?text=Quero%20reservar%20este%20produto:%20${productTitle}%20Valor:%20${moneyFormat(
            newPrice,
          )}`}
        >
          Reservar pelo Whatsapp
        </WhatsAppButton>
      )}

      {!whatsapp && instagram && (
        <ButtonInstagram href={`${instagram}`}>
          Reservar pelo Instagram
          <BsInstagram size={24} />
        </ButtonInstagram>
      )}

      {!whatsapp && !instagram && (
        <EmptyContactMessage>
          Esse mercado não adicionou uma forma de contato. Para mais
          informações, é necessário realizar o contato presencialmente.
        </EmptyContactMessage>
      )}
    </Container>
  );
};
